export default __webpack_public_path__ + "static/media/banner-call.f48600e4.jpg";